export default __webpack_public_path__ + "static/media/4-7t.480526e4.png";